// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"; // <-- Import useLocation
import StoryBanner from "./components/StoryBanner.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer";
import Avatar from "./pages/Avatar.js";
import Tile from "./components/Tile";
import BadgeList from "./components/BadgeList.js";
import LandingPage from "./pages/LandingPage.js";
import IslamicTrade from "./pages/IslamicTrade";
import Story from "./pages/Story.js";
import Home from "./pages/HomePage.js";
import IslamicTradePage1 from "./pages/IslamicTradePage1";
import IslamicTradePage2 from "./pages/IslamicTradePage2";
import IslamicTradePage3 from "./pages/IslamicTradePage3";
import IslamicTradePage4 from "./pages/IslamicTradePage4";
import IslamicTradePage5 from "./pages/IslamicTradePage5";
import IslamicTradePage6 from "./pages/IslamicTradePage6";
import IslamicTradePage7 from "./pages/IslamicTradePage7";
import IslamicTradePage8 from "./pages/IslamicTradePage8";
import IslamicTradePage9 from "./pages/IslamicTradePage9";
import IslamicTradePage10 from "./pages/IslamicTradePage10";
import IslamicTradePage11 from "./pages/IslamicTradePage11";
import IslamicTradePage12 from "./pages/IslamicTradePage12";
import IslamicTradePage13 from "./pages/IslamicTradePage13";
import IslamicTradePage14 from "./pages/IslamicTradePage14";
import IslamicTradePage15 from "./pages/IslamicTradePage15";
import IslamicTradePage16 from "./pages/IslamicTradePage16";
import IslamicTradePage17 from "./pages/IslamicTradePage17";
import IslamicTradePage18 from "./pages/IslamicTradePage18";
import IslamicTradePage19 from "./pages/IslamicTradePage19";
import IslamicTradePage20 from "./pages/IslamicTradePage20";
import IslamicTradePage21 from "./pages/IslamicTradePage21";
import IslamicTradePage22 from "./pages/IslamicTradePage22";
import IslamicTradePage23 from "./pages/IslamicTradePage23";
import IslamicTradePage24 from "./pages/IslamicTradePage24";
import IslamicTradePage25 from "./pages/IslamicTradePage25";
import BitcoinTech from "./pages/BitcoinTech.js";

import Economics26 from "./pages/Economics26";
import Economics27 from "./pages/Economics27";
import Economics28 from "./pages/Economics28";
import Economics29 from "./pages/Economics29";
import Economics30 from "./pages/Economics30";
import Economics31 from "./pages/Economics31";
import Economics32 from "./pages/Economics32";
import Economics33 from "./pages/Economics33";
import Economics34 from "./pages/Economics34";
import Economics35 from "./pages/Economics35";
import Economics36 from "./pages/Economics36";
import Economics37 from "./pages/Economics37";
import Economics38 from "./pages/Economics38";
import Economics39 from "./pages/Economics39";
import Economics40 from "./pages/Economics40";
import Economics41 from "./pages/Economics41";
import Economics42 from "./pages/Economics42";
import Economics43 from "./pages/Economics43";
import Economics44 from "./pages/Economics44";
import Economics45 from "./pages/Economics45.js";
import ContemporaryFinance51 from "./pages/ContemporaryFinance51.js";
import ContemporaryFinance52 from "./pages/ContemporaryFinance52.js";
import ContemporaryFinance53 from "./pages/ContemporaryFinance53.js";
import ContemporaryFinance54 from "./pages/ContemporaryFinance54.js";
import ContemporaryFinance55 from "./pages/ContemporaryFinance55.js";
import ContemporaryFinance56 from "./pages/ContemporaryFinance56.js";
import ContemporaryFinance57 from "./pages/ContemporaryFinance57.js";
import ContemporaryFinance60 from "./pages/ContemporaryFinance60.js";
import IslamicGuide61 from "./pages/IslamicGuide61.js";
import IslamicGuide62 from "./pages/IslamicGuide62.js";
import IslamicGuide63 from "./pages/IslamicGuide63.js";
import IslamicGuide64 from "./pages/IslamicGuide64.js";
import IslamicGuide65 from "./pages/IslamicGuide65.js";
import IslamicGuide66 from "./pages/IslamicGuide66.js";
import IslamicGuide67 from "./pages/IslamicGuide67.js";
import IslamicGuide68 from "./pages/IslamicGuide68.js";
import IslamicGuide69 from "./pages/IslamicGuide69.js";
import IslamicGuide70 from "./pages/IslamicGuide70.js";

import BitcoinTechPage71 from "./pages/BitcoinTechPage71";
import BitcoinTechPage72 from "./pages/BitcoinTechPage72";
import BitcoinTechPage73 from "./pages/BitcoinTechPage73";
import BitcoinTechPage74 from "./pages/BitcoinTechPage74";
import BitcoinTechPage75 from "./pages/BitcoinTechPage75";
import BitcoinTechPage76 from "./pages/BitcoinTechPage76";
import BitcoinTechPage77 from "./pages/BitcoinTechPage77";
import BitcoinTechPage78 from "./pages/BitcoinTechPage78.js";
import BitcoinTechPage80 from "./pages/BitcoinTechPage80";
import BitcoinTechPage81 from "./pages/BitcoinTechPage81";
import BitcoinTechPage82 from "./pages/BitcoinTechPage82";
import BitcoinTechPage83 from "./pages/BitcoinTechPage83.js";
import BitcoinTechPage84 from "./pages/BitcoinTechPage84.js";
import BitcoinTechPage85 from "./pages/BitcoinTechPage85.js";
import BitcoinTechPage86 from "./pages/BitcoinTechPage86.js";
import BitcoinTechPage87 from "./pages/BitcoinTechPage87.js";
import BitcoinTechPage88 from "./pages/BitcoinTechPage88.js";
import BitcoinTechPage89 from "./pages/BitcoinTechPage89.js";
import BitcoinTechPage90 from "./pages/BitcoinTechPage90.js";
import DIY97 from "./pages/DIY97.js";
import DIY98 from "./pages/DIY98.js";
import DIY99 from "./pages/DIY99.js";
import DIY100 from "./pages/DIY100.js";
import LightningTech from "./pages/LightningTech";
import AustrianEconomics from "./pages/Economics";
import IndexPage from "./pages/IndexPage";
import IndexLightning from "./pages/IndexLightning.js";
import IndexApexAsset from "./pages/IndexApexAsset.js";
import ForewordIslamicJurisprudence from "./pages/ForewordIslamicFinance.js";
import ForewordEconomics from "./pages/ForewordEconomics.js";
import ForewordApex from "./pages/ForewordApex.js";
import ForewordContemporaryInstitutes from "./pages/ForewordContemporaryInstitutes.js";
import ForewordGuide from "./pages/ForewordGuide.js";
import ForewordBitcoinTech from "./pages/ForewordBitcoinTech.js";
import ForewordLightning from "./pages/ForewordLightning.js";

import "./App.css";
import IndexPageBitcoinTech from "./pages/IndexBitcoinTech";
import IndexEconomics from "./pages/IndexEconomics";
import IndexFinance from "./pages/IndexFinance";
import IndexIslamicGuide from "./pages/IndexIslamicGuide";
import IndexDIY from "./pages/IndexDIY.js";
import ApexAsset46 from "./pages/ApexAsset46.js";
import ApexAsset47 from "./pages/ApexAsset47.js";
import ApexAsset48 from "./pages/ApexAsset48.js";
import ApexAsset49 from "./pages/ApexAsset49.js";
import ApexAsset50 from "./pages/ApexAsset50.js";
import Lightning91 from "./pages/Lightning91.js";
import Lightning92 from "./pages/Lightning92.js";
import Lightning93 from "./pages/Lightning93.js";
import Lightning94 from "./pages/Lightning.94.js";
import DIY96 from "./pages/DIY96.js";

// Component to handle conditional rendering of Header/Footer
function AppContent() {
  const location = useLocation();
  // Check if the current path is the landing page
  const isLandingPage = location.pathname === "/";
  // Check if the current path is the home page
  const isHomePage = location.pathname === "/home";

  return (
    <div id="root">
      {/* Render Header only if it is NOT the landing page */}
      {!isLandingPage && <Header />}
      <div className="App">
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/avatar" element={<Avatar />} />
          <Route path="/" element={<MainContent />} />
          <Route path="/badgelist" element={<BadgeList />} />
          <Route path="/index" element={<IndexPage />} />
          <Route
            path="/index-bitcoin-tech"
            element={<IndexPageBitcoinTech />}
          />
          <Route path="/index-apex-asset" element={<IndexApexAsset />} />
          <Route path="/index-lightning" element={<IndexLightning />} />
          <Route path="/index-economics" element={<IndexEconomics />} />
          <Route path="/index-finance" element={<IndexFinance />} />
          <Route path="/index-diy" element={<IndexDIY />} />
          <Route
            path="/foreword-islamic-jurisprudence"
            element={<ForewordIslamicJurisprudence />}
          />
          <Route path="/foreword-economics" element={<ForewordEconomics />} />
          <Route path="/foreword-apex" element={<ForewordApex />} />
          <Route
            path="/foreword-contemporary-institutes"
            element={<ForewordContemporaryInstitutes />}
          />
          <Route path="/foreword-guide" element={<ForewordGuide />} />
          <Route
            path="/foreword-bitcointech"
            element={<ForewordBitcoinTech />}
          />
          <Route
            path="/foreword-lightningtech"
            element={<ForewordLightning />}
          />
          <Route path="/islamic-finance" element={<IslamicTrade />} />
          <Route path="/index-islamicguide" element={<IndexIslamicGuide />} />
          <Route path="/islamic-trade-page-1" element={<IslamicTradePage1 />} />
          {/* THE TARGET ROUTE: The header/footer is hidden on this page */}
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/islamic-trade-page-2" element={<IslamicTradePage2 />} />
          <Route path="/islamic-trade-page-3" element={<IslamicTradePage3 />} />
          <Route path="/islamic-trade-page-4" element={<IslamicTradePage4 />} />
          <Route path="/islamic-trade-page-5" element={<IslamicTradePage5 />} />
          <Route path="/islamic-trade-page-6" element={<IslamicTradePage6 />} />
          <Route path="/islamic-trade-page-7" element={<IslamicTradePage7 />} />
          <Route path="/islamic-trade-page-8" element={<IslamicTradePage8 />} />
          <Route path="/islamic-trade-page-9" element={<IslamicTradePage9 />} />
          <Route
            path="/islamic-trade-page-10"
            element={<IslamicTradePage10 />}
          />
          <Route
            path="/islamic-trade-page-11"
            element={<IslamicTradePage11 />}
          />
          <Route
            path="/islamic-trade-page-12"
            element={<IslamicTradePage12 />}
          />
          <Route
            path="/islamic-trade-page-13"
            element={<IslamicTradePage13 />}
          />
          <Route
            path="/islamic-trade-page-14"
            element={<IslamicTradePage14 />}
          />
          <Route
            path="/islamic-trade-page-15"
            element={<IslamicTradePage15 />}
          />
          <Route
            path="/islamic-trade-page-16"
            element={<IslamicTradePage16 />}
          />
          <Route
            path="/islamic-trade-page-17"
            element={<IslamicTradePage17 />}
          />
          <Route
            path="/islamic-trade-page-18"
            element={<IslamicTradePage18 />}
          />
          <Route
            path="/islamic-trade-page-19"
            element={<IslamicTradePage19 />}
          />
          <Route
            path="/islamic-trade-page-20"
            element={<IslamicTradePage20 />}
          />
          <Route
            path="/islamic-trade-page-21"
            element={<IslamicTradePage21 />}
          />
          <Route
            path="/islamic-trade-page-22"
            element={<IslamicTradePage22 />}
          />
          <Route
            path="/islamic-trade-page-23"
            element={<IslamicTradePage23 />}
          />
          <Route
            path="/islamic-trade-page-24"
            element={<IslamicTradePage24 />}
          />
          <Route
            path="/islamic-trade-page-25"
            element={<IslamicTradePage25 />}
          />
          <Route path="/economics-26" element={<Economics26 />} />
          <Route path="/economics-27" element={<Economics27 />} />
          <Route path="/economics-28" element={<Economics28 />} />
          <Route path="/economics-29" element={<Economics29 />} />
          <Route path="/economics-30" element={<Economics30 />} />
          <Route path="/economics-31" element={<Economics31 />} />
          <Route path="/economics-32" element={<Economics32 />} />
          <Route path="/economics-33" element={<Economics33 />} />
          <Route path="/economics-34" element={<Economics34 />} />
          <Route path="/economics-35" element={<Economics35 />} />
          <Route path="/economics-36" element={<Economics36 />} />
          <Route path="/economics-37" element={<Economics37 />} />
          <Route path="/economics-38" element={<Economics38 />} />
          <Route path="/economics-39" element={<Economics39 />} />
          <Route path="/economics-40" element={<Economics40 />} />
          <Route path="/economics-41" element={<Economics41 />} />
          <Route path="/economics-42" element={<Economics42 />} />
          <Route path="/economics-43" element={<Economics43 />} />
          <Route path="/economics-44" element={<Economics44 />} />
          <Route path="/economics-45" element={<Economics45 />} />
          <Route path="/apex-asset-46" element={<ApexAsset46 />} />
          <Route path="/apex-asset-47" element={<ApexAsset47 />} />
          <Route path="/apex-asset-48" element={<ApexAsset48 />} />
          <Route path="/apex-asset-49" element={<ApexAsset49 />} />
          <Route path="/apex-asset-50" element={<ApexAsset50 />} />
          <Route path="/islamicguide-61" element={<IslamicGuide61 />} />
          <Route path="/islamicguide-62" element={<IslamicGuide62 />} />
          <Route path="/islamicguide-63" element={<IslamicGuide63 />} />
          <Route path="/islamicguide-64" element={<IslamicGuide64 />} />
          <Route path="/islamicguide-65" element={<IslamicGuide65 />} />
          <Route path="/islamicguide-66" element={<IslamicGuide66 />} />
          <Route path="/islamicguide-67" element={<IslamicGuide67 />} />
          <Route path="/islamicguide-68" element={<IslamicGuide68 />} />
          <Route path="/islamicguide-69" element={<IslamicGuide69 />} />
          <Route path="/islamicguide-70" element={<IslamicGuide70 />} />
          <Route
            path="/contemporaryfinance-51"
            element={<ContemporaryFinance51 />}
          />
          <Route
            path="/contemporaryfinance-52"
            element={<ContemporaryFinance52 />}
          />
          <Route
            path="/contemporaryfinance-53"
            element={<ContemporaryFinance53 />}
          />
          <Route
            path="/contemporaryfinance-54"
            element={<ContemporaryFinance54 />}
          />
          <Route
            path="/contemporaryfinance-55"
            element={<ContemporaryFinance55 />}
          />
          <Route
            path="/contemporaryfinance-56"
            element={<ContemporaryFinance56 />}
          />
          <Route
            path="/contemporaryfinance-57"
            element={<ContemporaryFinance57 />}
          />
          <Route
            path="/contemporaryfinance-60"
            element={<ContemporaryFinance60 />}
          />

          <Route path="/bitcoin-tech-page-71" element={<BitcoinTechPage71 />} />
          <Route path="/bitcoin-tech-page-72" element={<BitcoinTechPage72 />} />
          <Route path="/bitcoin-tech-page-73" element={<BitcoinTechPage73 />} />

          <Route path="/bitcoin-tech-page-74" element={<BitcoinTechPage74 />} />
          <Route path="/bitcoin-tech-page-75" element={<BitcoinTechPage75 />} />
          <Route path="/bitcoin-tech-page-76" element={<BitcoinTechPage76 />} />
          <Route path="/bitcoin-tech-page-77" element={<BitcoinTechPage77 />} />
          <Route path="/bitcoin-tech-page-78" element={<BitcoinTechPage78 />} />
          <Route path="/bitcoin-tech-page-80" element={<BitcoinTechPage80 />} />
          <Route path="/bitcoin-tech-page-81" element={<BitcoinTechPage81 />} />
          <Route path="/bitcoin-tech-page-82" element={<BitcoinTechPage82 />} />
          <Route path="/bitcoin-tech-page-83" element={<BitcoinTechPage83 />} />
          <Route path="/bitcoin-tech-page-84" element={<BitcoinTechPage84 />} />
          <Route path="/bitcoin-tech-page-85" element={<BitcoinTechPage85 />} />
          <Route path="/bitcoin-tech-page-86" element={<BitcoinTechPage86 />} />
          <Route path="/bitcoin-tech-page-87" element={<BitcoinTechPage87 />} />
          <Route path="/bitcoin-tech-page-88" element={<BitcoinTechPage88 />} />
          <Route path="/bitcoin-tech-page-89" element={<BitcoinTechPage89 />} />
          <Route path="/bitcoin-tech-page-90" element={<BitcoinTechPage90 />} />
          <Route path="/lightning-91" element={<Lightning91 />} />
          <Route path="/lightning-92" element={<Lightning92 />} />
          <Route path="/lightning-93" element={<Lightning93 />} />
          <Route path="/lightning-94" element={<Lightning94 />} />
          <Route path="/diy-96" element={<DIY96 />} />
          <Route path="/diy-97" element={<DIY97 />} />
          <Route path="/diy-98" element={<DIY98 />} />
          <Route path="/diy-99" element={<DIY99 />} />
          <Route path="/diy-100" element={<DIY100 />} />
          <Route path="/bitcoin-tech" element={<BitcoinTech />} />
          <Route path="/lightning-tech" element={<LightningTech />} />
          <Route path="/austrian-economics" element={<AustrianEconomics />} />
        </Routes>
      </div>
      {/* Render Footer only on the home page */}
      {isHomePage && <Footer />}
    </div>
  );
}

// The main App component just contains the Router and AppContent
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

// MainContent is unchanged
function MainContent() {
  return <LandingPage />;
}

export default App;
